<div>
  <div class="title">
    <h2 class="primary" i18n="@@Upload PDF">Upload PDF</h2>
  </div>
  <div>
    <div class="dottedBox secondaryTextColor my-drop-zone" style="min-height: 100px;" appNg2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" [uploader]="uploader">
      <div class="fileUploader">
        <input mat-raised-button style="background-color: #60b700; color: white;" type="file" appNg2FileSelect [uploader]="uploader" accept="application/pdf" (change)="onFileSelected($event)">
        <p class="secondaryTextColor" i18n="@@PDF files accepted">.pdf files accepted.</p>
      </div>
      <p i18n="@@UploadPDFInstructions">Drag and drop a PDF file here, or click to select a file. The PDF will be used as the content for this draft.</p>
    </div>
    <div *ngIf="uploadFileMessages && uploadFileMessages.length > 0"><p *ngFor="let message of uploadFileMessages">{{message}}</p></div>
    <div *ngIf="uploadFileErrorMessages && uploadFileErrorMessages.length > 0" style="color: red;"><p *ngFor="let message of uploadFileErrorMessages">{{message}}</p></div>
    <!--
      `btn-sec` rather than an inline `margin-top` + `text-align: right`.
      That is the class every other dialog's action row uses, and it is
      what `src/dialogs.css` hangs the shared footer bar off: hairline,
      tint, gutter, pill buttons. Inline styles here produced a bare
      right-aligned button floating in the body, which is exactly the
      inconsistency this class exists to prevent.
    -->
    <div class="btn-sec">
      <button mat-raised-button class="Discard-btn" (click)="dialogRef.close()" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
    </div>
  </div>
</div>
